const MONTHS_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const getMonthYearObj = (YEAR: number, MONTH: number) => {
  const STR_MONTH = `0${(MONTH + 1).toString()}`.slice(-2);
  return {
    id: `${YEAR}-${STR_MONTH}`,
    label: `${MONTHS_NAMES[MONTH]} ${YEAR}`,
    value: `${YEAR}-${STR_MONTH}`,
  };
};

export const getYearMonthRange = (startTS: string, endTS?: string) => {
  const start = new Date(startTS);
  const end = !!endTS ? new Date(endTS) : new Date();
  const startYear = start.getFullYear();
  let startMonth = start.getMonth();
  const endYear = end.getFullYear();
  let endMonth = end.getMonth();
  const list = [];
  for (let year = startYear; year <= endYear; year += 1) {
    startMonth = year !== startYear ? 0 : startMonth;
    endMonth = year !== endYear ? 11 : endMonth;
    for (let month = startMonth; month <= endMonth; month += 1) {
      list.push(getMonthYearObj(year, month));
    }
  }
  return list;
};

export const getMonthsNameMap = (YEAR: string) => {
  return {
    '01': `January ${YEAR}`,
    '02': `February ${YEAR}`,
    '03': `March ${YEAR}`,
    '04': `April ${YEAR}`,
    '05': `May ${YEAR}`,
    '06': `June ${YEAR}`,
    '07': `July ${YEAR}`,
    '08': `August ${YEAR}`,
    '09': `September ${YEAR}`,
    '10': `October ${YEAR}`,
    '11': `November ${YEAR}`,
    '12': `December ${YEAR}`,
  };
};



// WEBPACK FOOTER //
// ./constants/dashboard/monthlyStatement.ts